import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { Cy_Katalog } from '@features/cypress';
import { PublicRestService } from '@generated/be';
import { KodNazevPipe, PublicSablonyTypStatuses } from '@reza-ais-fe/reza-ais-fe-utils';
import {
  BrowseFilterComponent,
  BrowseTableDirective,
  ButtonsComponent,
  StatusIndicatorComponent,
} from '@shared/ui/components';
import { downloadFile, publicApiArgs } from '@shared/utils';
import { ButtonModule } from '@openng/optimus-ui/button';
import { TableModule } from '@openng/optimus-ui/table';
import { SeznamSablonFilterFormService } from '../../../services/seznam-sablon-filter-form.service';
import { SeznamSablonStateService } from '../../../services/seznam-sablon-state.service';
import { SablonyFilterComponent } from '../seznam-sablon-filter/seznam-sablon-filter.component';

/** Veřejný katalog šablon: filtr v akordeonu a tabulka se stažením PDF a dokumentace. */
@Component({
  selector: 'reza-seznam-sablon-overview-filter',
  imports: [
    AsyncPipe,
    DatePipe,
    ReactiveFormsModule,
    RouterLink,
    BrowseFilterComponent,
    BrowseTableDirective,
    TableModule,
    ButtonsComponent,
    ButtonModule,
    SablonyFilterComponent,
    StatusIndicatorComponent,
    KodNazevPipe,
  ],
  templateUrl: './seznam-sablon-overview-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeznamSablonOverviewFilterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly publicRestService = inject(PublicRestService);
  private readonly router = inject(Router);

  readonly filterForm = inject(SeznamSablonFilterFormService).filterForm;
  readonly state = inject(SeznamSablonStateService);
  readonly publicSablonyTypStatuses = PublicSablonyTypStatuses;
  readonly Cy_Katalog = Cy_Katalog;

  ngOnInit(): void {
    this.state.connectResult();
  }

  submitFilter(): void {
    this.state.findWithNewFilter(this.filterForm.value);
  }

  clearFilter(): void {
    this.state.findWithClearFilter(this.filterForm.value);
  }

  downloadPdf(id: number): void {
    this.publicRestService
      .getPdfSablony({ id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => downloadFile(res, `${id}.pdf`));
  }

  downloadDokumentace(id: number): void {
    this.publicRestService
      .getDokumentace({ id }, ...publicApiArgs())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => downloadFile(res, `${id}.pdf`));
  }

  goBack(): void {
    this.router.navigate(['']);
  }
}
